"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToastContainer = void 0;
/*
 * Package Import
 */
const styled_1 = __importDefault(require("@emotion/styled"));
// Toastify
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
/*
 * Local Import
 */
const success_svg_1 = __importDefault(require("assets/images/icons/success.svg"));
const danger_svg_1 = __importDefault(require("assets/images/icons/danger.svg"));
const colors = {
    success: { primary: '#057A55', secondary: '#F3FAF7' },
    danger: { primary: '#E02424', secondary: '#FDF2F2' },
};
/**
 * Get the SVG's URL from color
 */
const getUrlByColor = (color) => {
    const urls = { success: success_svg_1.default, danger: danger_svg_1.default };
    return urls[color];
};
/*
 * Style
 */
const getToastStyle = (title, color) => ({
    display: 'flex',
    border: `2px solid ${colors[color].primary}`,
    minHeight: '0',
    height: '3.6rem',
    flexDirection: 'column',
    justifyContent: 'space-around',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
    color: '#1A202E',
    fontSize: '0.6rem',
    fontWeight: 'lighter',
    paddingLeft: '2.8rem',
    '&::before': {
        marginTop: '0.5rem',
        paddingLeft: '0.4rem',
        fontSize: '0.7rem',
        content: `"${title}"`,
        fontWeight: 'bold',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: '0',
        bottom: '0',
        margin: 'auto',
        left: '0.2rem',
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        backgroundColor: colors[color].secondary,
        padding: '1rem',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '70%',
        display: 'block',
        backgroundImage: `url(${getUrlByColor(color)})`,
    },
});
exports.StyledToastContainer = (0, styled_1.default)(react_toastify_1.ToastContainer)(() => ({
    '.Toastify__toast-body': {
        paddingTop: '0',
    },
    '.Toastify__close-button': {
        position: 'absolute',
        top: '0',
        bottom: '0',
        margin: 'auto',
        right: '0.2rem',
        color: '#1A202E',
    },
    '.Toastify__toast--success': Object.assign({}, getToastStyle('Succès !', 'success')),
    '.Toastify__toast--error': Object.assign({}, getToastStyle('Erreur !', 'danger')),
}));
